import { useTranslation } from 'react-i18next'
import './Footer.css'

function Footer() {

    const {t} = useTranslation()

    return (
        <>
            <section className="container-fluid footer">
                <section className="container-lg footer-body">
                    <div className='footer-body__left'>
                        <img src="kam-tech-logo-white-transparent.png" alt="logo" width={128} />
                        <section>
                            <p className='p-0 m-0'>Kam-Tech-2024. All rights reserved<sup><span>&copy;</span></sup></p>
                            <p className='p-0 m-0'>+48 731-196-509</p>
                            <p className='p-0 m-0'>Kołomań 75, Zagnańsk 26-050</p>
                            <p className='p-0 m-0'>Piotr Kubicki</p>
                            <div className='d-flex justify-content-between'>
                                <a href="https://www.youtube.com/watch?v=zknmfaYyma8" target='_blank' className=''><img src="icons/youtube.svg" style={{ width: "32px" }} alt="" /></a>
                                <a href="https://www.facebook.com/share/v/14TtYDV9BD/?mibextid=WC7FNe" target='_blank' className=''><img src="icons/facebook.svg" style={{ width: "32px" }} alt="" /></a>
                                <a href="https://www.instagram.com/kubickipiotr8/" target='_blank' className=''><img src="icons/instagram.svg" style={{ width: "32px" }} alt="" /></a>
                                <a href="https://www.tiktok.com/@kubickipiotr?_t=8rfSYXlrwV4&_r=1" target='_blank' className=''><img src="icons/tiktok.svg" style={{ width: "32px" }} alt="" /></a>
                            </div>
                        </section>
                    </div>

                    <p className='p-0 footer-body__right'>{t("footer.madeby")}: <a href="https://linkedin.com/in/aleksander-radłowskii" target="_blank" rel="noopener noreferrer" className='text-decoration'>
                    <span className='underline'>Aleksander Radłowski</span></a></p>

                </section>
            </section>
        </>
    )
}
export default Footer